export default __webpack_public_path__ + "fonts/nunito-v25-latin-600.woff2";